import React from 'react'
import Grid from '@mui/material/Grid'
import { getDescendants, getUniqueAreasOfLaw } from 'services/LegislationService'
import Tile from './Tile'

const LegislationTiledMenu = ({
  folders,
  getUrl,
  category,
  cxNames,
  showFavouritesOnly,
  favourites,
  setFavourites,
  selectedAols,
  setSelectedAols,
  keyword,
  ...props
}) => {
  const safeKeyword = keyword.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(safeKeyword, 'i')

  const renderedTiles = folders.reduce((acc, folder, index) => {
    if (showFavouritesOnly && !favourites.includes(folder.name)) {
      return acc
    }
    const descendants = safeKeyword.length > 0
      ? getDescendants(folder.categories)
      : []
    const matchingDescendants = descendants.filter(descendant => descendant.title.match(regex))
    const aols = getUniqueAreasOfLaw(folder)

    if (selectedAols.length > 0 && !selectedAols.some(aol => aols.includes(aol))) return acc
    if (safeKeyword.length > 0 && matchingDescendants.length === 0) return acc

    return [
      ...acc,
      (
        <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
          <Tile
            id={folder.name}
            getUrl={getUrl({ name: folder.name })}
            title={folder.name}
            active
            showInactive
            hideInfo
            category={category}
            cxNames={cxNames}
            showFavouritesOnly={showFavouritesOnly}
            favourites={favourites}
            keyword={keyword}
            setFavourites={setFavourites}
            matchingDescendants={matchingDescendants}
            aols={aols}
            {...props}
          />
        </Grid>
      )
    ]
  }, [])

  return (
    <nav>
      {folders.length > 0 && renderedTiles.length > 0 && (
        <Grid container spacing={2}>
          {renderedTiles}
        </Grid>
      )}
      {renderedTiles.length === 0 && (
        <p className='f2 tc i'>
          {safeKeyword.length > 0 ? `No results for keyword "${keyword}"` : 'No favourites selected'}
        </p>
      )}
    </nav>
  )
}

export default LegislationTiledMenu
